import {
  InfoStatWidgets,
  LastRegistrationApp,
  MetricSummaryWidgets,
  STATUSPAGE,
} from '@repo/ui';
import { ChartOngoingActivityByInstitution } from 'presentation/app/components/charts/chart-ongoing-activities-by-institution';
import { useEntity } from 'presentation/app/modules/Entities/hooks/use-entity-overview';
import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';

import { ChartGroupBar } from '../../../chart-group';
import { ChartStudentsWithAndWithoutApp } from '../../../chart-students-with-and-without-app';

interface IProps {
  entityId: string;
}

export const Overview = ({ entityId }: IProps) => {
  const {
    requestStudentsCount,
    requestPositionCountForEntity,
    studentsCountInfo,
    studentsCountResult,
    dataEntityRoleCount,
    loadingStudentsCount,
    loadingPositionCountForEntity,

    //
    requestGroupsCount,
    //
    loadingOngoingActivities,
    ongoingActivityByCourse,
    requestOngoingActivitiesByCourse,
    //
    requestStudentsRegisteredForOrganization,
    loadingStudentsRegisteredForOrganization,
    studentsRegisteredForOrganizationFormate,
    groupsCount,
  } = useEntity();

  //
  const colorsCartDonut = ['#1b6654', '#ff0000'];

  const legendItems = [
    { label: 'Com APP', colorClass: colorsCartDonut[0], icon: 'smartphone' },
    {
      label: 'Sem APP',
      colorClass: colorsCartDonut[1],
      icon: 'phone-off',
    },
  ];

  const labelsCartDonut = [legendItems[0].label, legendItems[1].label];

  const titleChartDonut = 'Estudantes';

  const noDataLastRegistrationConfig = {
    noDataTitle: 'Nenhum estudante encontrado',
    noDataDescription: 'Não há estudantes cadastrados para esta organização.',
  };

  useEffect(() => {
    requestGroupsCount({ id: entityId });
    requestStudentsCount({ id: entityId });
    requestPositionCountForEntity({ id: entityId });
    requestOngoingActivitiesByCourse({ id: entityId });
    requestStudentsRegisteredForOrganization({ id: entityId });
  }, []);

  return (
    <div className="p-3 mt-5">
      <MetricSummaryWidgets
        iconLib="remix"
        data={dataEntityRoleCount}
        loading={loadingPositionCountForEntity}
      />

      <InfoStatWidgets
        iconLib="remix"
        data={studentsCountInfo}
        status={loadingStudentsCount}
      />

      <Row>
        <React.Fragment>
          <Col md={4} lg={4} xl={4}>
            <ChartGroupBar groupsCount={groupsCount} />
          </Col>
          <Col md={4} lg={4} xl={4}>
            <ChartStudentsWithAndWithoutApp
              legendItems={legendItems}
              colorsCartDonut={colorsCartDonut}
              labelsCartDonut={labelsCartDonut}
              titleChartDonut={titleChartDonut}
              studentsWithAndApp={{
                studentsWithApp: studentsCountResult?.withApp,
                studentsWithoutApp: studentsCountResult?.withoutApp,
              }}
              loading={STATUSPAGE.DONE}
            />
          </Col>
          <Col md={4} lg={4} xl={4}>
            <LastRegistrationApp
              noDataTitle={noDataLastRegistrationConfig.noDataTitle}
              noDataDescription={noDataLastRegistrationConfig.noDataDescription}
              loading={loadingStudentsRegisteredForOrganization}
              title="Últimos Estudantes Cadastrados"
              data={studentsRegisteredForOrganizationFormate}
            />
          </Col>

          <Col md={12}>
            <ChartOngoingActivityByInstitution
              loading={loadingOngoingActivities}
              height={500}
              data={ongoingActivityByCourse}
              title="Atividades em Andamento por Curso"
            />
          </Col>
        </React.Fragment>
      </Row>
    </div>
  );
};
